/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_Multiview_TitleInputs */



/**
* | output |
* | --- |
* | "Split Multiview Group" |
*
* @param {Split_Multiview_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_title = /** @type {((inputs?: Split_Multiview_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe multivue fractionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Split Multiview Group")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dividi il gruppo Multivista")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разделение группы с несколькими окнами просмотра")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo multivista dividido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拆分多视图组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分割マルチビューグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्प्लिट मल्टीव्यू ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de visualização múltipla dividido")
	return /** @type {LocalizedString} */ ("Split Multiview Group")
});